import { render, staticRenderFns } from "./header-notification.vue?vue&type=template&id=70930f15&scoped=true"
import script from "./header-notification.vue?vue&type=script&lang=js"
export * from "./header-notification.vue?vue&type=script&lang=js"
import style0 from "./header-notification.vue?vue&type=style&index=0&id=70930f15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70930f15",
  null
  
)

export default component.exports